angular.module('qkr').factory('registrationService', ($http, appConfig, $q) => ({

        verifyCode(vcode) {
            const deferred = $q.defer();
        	$http.get(appConfig.apiUrl + 'registration/verifyCode/' + vcode.trim() + '?from_mss=true', {withCredentials: true}).then(
                (response) => {
                    deferred.resolve(response.data);
                },
                (reason) => {
                    deferred.reject(reason.data);
                });

            return deferred.promise;
        }

    }));




// WEBPACK FOOTER //
// ./src/services/registration.services.js